import { Stage } from '../../types/bookings';

const translationFileName = 'bookingStageInformation';

export const landlordBookingStageInformationText = {
  [Stage.Pending]: `${translationFileName}:landlordBookingStagePendingInformation`,
  [Stage.Rejected]: `${translationFileName}:landlordBookingStageRejectedInformation`,
  [Stage.Accepted]: `${translationFileName}:landlordBookingStageAcceptedInformation`,
  [Stage.CreditNotVerified]: `${translationFileName}:landlordBookingStageCreditAnalysisRejectedInformation`,
  [Stage.CreditVerified]: `${translationFileName}:landlordBookingStageCreditAnalysisAcceptedInformation`,
  [Stage.ContractCreated]: `${translationFileName}:landlordBookingStageContractHoldingInformation`,
  [Stage.CheckInKo]: `${translationFileName}:landlordBookingStageRejectedInformation`,
} as const;

export type landlordBookingStageInformationTextKey =
  keyof typeof landlordBookingStageInformationText;

export type landlordBookingStageInformationTextType =
  typeof landlordBookingStageInformationText[landlordBookingStageInformationTextKey];

export const landlordBookingStageInformationTextKeys = Object.keys(
  landlordBookingStageInformationText,
);

export const tenantBookingStageInformationText = {
  [Stage.Draft]: `${translationFileName}:tenantBookingStageDraftInformation`,
  [Stage.Pending]: `${translationFileName}:tenantBookingStagePendingInformation`,
  [Stage.Accepted]: `${translationFileName}:tenantBookingStageAcceptedInformation`,
  [Stage.Rejected]: `${translationFileName}:tenantBookingStageRejectedInformation`,
  [Stage.CreditNotVerified]: `${translationFileName}:tenantBookingStageCreditAnalysisRejectedInformation`,
  [Stage.CreditVerified]: `${translationFileName}:tenantBookingStageCreditAnalysisAcceptedInformation`,
  [Stage.ContractCreated]: `${translationFileName}:tenantBookingStageContractHoldingInformation`,
  [Stage.CheckInKo]: `${translationFileName}:tenantBookingStageCheckInRejected`,
} as const;

export type tenantBookingStageInformationTextKey =
  keyof typeof tenantBookingStageInformationText;

export type tenantBookingStageInformationTextType =
  typeof tenantBookingStageInformationText[tenantBookingStageInformationTextKey];

export const tenantBookingStageInformationTextKeys = Object.keys(
  tenantBookingStageInformationText,
);
